// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";
import Validator from "@classes/Validator";

// COMPONENTS
import DefaultFields from "../../../components/DefaultFields/DefaultFields";

// HELPERS
import {createClassName} from "@helpers/utils";
import * as CobHelpers from "../../../Cob.helpers";
import fulfillmentCheck from "./KycForetag.fulfillment";
import SizeOfDeposits from "../../../components/KYC/SizeOfDeposits";
import FrequencyOfDeposits from "../../../components/KYC/FrequencyOfDeposits";
import SizeOfTurnover from "../../../components/KYC/SizeOfTurnover";
import NumberOfEmployees from "../../../components/KYC/NumberOfEmployees";
import OriginOfCompanyFunds from "../../../components/KYC/OriginOfCompanyFunds";
import TypeOfCompany from "../../../components/KYC/TypeOfCompany";
import OptionsList from "../../../components/OptionsList/OptionsList";
import NumberField from "../../../components/NumberField/NumberField";
import EditableField from "../../../components/EditableField/EditableField";
import FieldsCollection from "../../../../../components/FieldsCollection/FieldsCollection";
import UboFields from "../../../components/UboFields/UboFields";
import TextField from "../../../../../components/TextField/TextField";
import PepQuestions from "../../../components/PepQuestions/PepQuestions";


export default class KycForetag extends React.PureComponent
{
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired
	};

	static companyExclusive = true;
	static privateExclusive = false;
	static fields = _getFields();

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState)
	{
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields)
		{
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render()
	{
		const {props, state} = this;
		const {title} = props;
		const classes = createClassName("Cob-CustomerInformation", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields} />

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<h3>Uppgifter om företaget</h3>

					<h4 style={{margin: "0 0 20px 0"}}>I vilken bransch verkar företaget</h4>
					<EditableField
						Component={TextField}
						name="company_business"
						label="Ange"
						value={state.fields.company_business}
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
						valid={!state.fields.company_business ? null : (state.fields.company_business.length > 0)}
					/>


					<h4 style={{margin: "20px 0 0 0"}}>Historiskt resultat</h4>

					<p>Ange siffror för årsbokslut, före skatt.</p>

					<FieldsCollection
						fieldsPerRow={3}
						fields={[
							{
								render: (
									<EditableField
										Component={NumberField}
										name="customer_comp_histresult1"
										label="1 år sedan (senaste bokslut)"
										value={state.fields.customer_comp_histresult1}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										valid={!state.fields.customer_comp_histresult1 ? null : (state.fields.customer_comp_histresult1.length > 0 && state.fields.customer_comp_histresult1 !== "-")}
										unit={"kr"}
									/>
								)
							},
							{
								render: (
									<EditableField
										Component={NumberField}
										name="customer_comp_histresult2"
										label="2 år sedan"
										value={state.fields.customer_comp_histresult2}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										valid={!state.fields.customer_comp_histresult2 ? null : (state.fields.customer_comp_histresult2.length > 0 && state.fields.customer_comp_histresult2 !== "-")}
										unit={"kr"}
									/>
								)
							},
							{
								render: (
									<EditableField
										Component={NumberField}
										name="customer_comp_histresult3"
										label="3 år sedan"
										value={state.fields.customer_comp_histresult3}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										valid={!state.fields.customer_comp_histresult3 ? null : (state.fields.customer_comp_histresult3.length > 0 && state.fields.customer_comp_histresult3 !== "-")}
										unit={"kr"}
									/>
								)
							}
						]}
					/>

					<h4 style={{margin: "20px 0 0 0"}}>Uppskattat resultat kommande period</h4>

					<p>Ange siffror för kommande årsbokslut, före skatt.</p>

					<FieldsCollection
						fieldsPerRow={2}
						fields={[
							{
								render: (
									<EditableField
										Component={NumberField}
										name="customer_comp_budresult12m"
										label="12 månader (nästkommande bokslut)"
										value={state.fields.customer_comp_budresult12m}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										valid={!state.fields.customer_comp_budresult12m ? null : (state.fields.customer_comp_budresult12m.length > 0 && state.fields.customer_comp_budresult12m !== "-")}
										unit={"kr"}
									/>
								)
							},
							{
								render: (
									<EditableField
										Component={NumberField}
										name="customer_comp_budresult24m"
										label="24 månader"
										value={state.fields.customer_comp_budresult24m}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										valid={!state.fields.customer_comp_budresult24m ? null : (state.fields.customer_comp_budresult24m.length > 0 && state.fields.customer_comp_budresult24m !== "-")}
										unit={"kr"}
									/>
								)
							}
						]}
					/>

					<h4 style={{margin: "20px 0 "}}>Tillgångar</h4>

					<FieldsCollection
						fieldsPerRow={2}
						fields={[
							{
								render: (
									<EditableField
										Component={NumberField}
										name="customer_comp_assets_cash"
										label="Bankkonto"
										value={state.fields.customer_comp_assets_cash}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										valid={!state.fields.customer_comp_assets_cash ? null : (state.fields.customer_comp_assets_cash.length > 0 && state.fields.customer_comp_assets_cash !== "-")}
										unit={"kr"}
									/>
								)
							},
							{
								render: (
									<EditableField
										Component={NumberField}
										name="customer_comp_assets_fininstr"
										label="Finansiella instrument"
										value={state.fields.customer_comp_assets_fininstr}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										valid={!state.fields.customer_comp_assets_fininstr ? null : (state.fields.customer_comp_assets_fininstr.length > 0 && state.fields.customer_comp_assets_fininstr !== "-")}
										unit={"kr"}
									/>
								)
							},
							{
								render: (
									<EditableField
										Component={NumberField}
										name="customer_comp_assets_other"
										label="Övrigt (t.ex. moms eller skatteskulder)"
										value={state.fields.customer_comp_assets_other}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										valid={!state.fields.customer_comp_assets_other ? null : (state.fields.customer_comp_assets_other.length > 0 && state.fields.customer_comp_assets_other !== "-")}
										unit={"kr"}
									/>
								)
							},
							{
								render: (
									<EditableField
										Component={NumberField}
										name="customer_comp_assets_sum"
										label="Summa placeringsbara tillgångar"
										value={state.fields.customer_comp_assets_sum}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										valid={!state.fields.customer_comp_assets_sum ? null : (state.fields.customer_comp_assets_sum.length > 0 && state.fields.customer_comp_assets_sum !== "-")}
										unit={"kr"}
									/>
								)
							}
						]}
					/>

					<UboFields onChange={this._onUboChange} session={this.props.session}/>

					<PepQuestions onUpdate={this._onPepChange} appliesToUbo={this.props.session.isCompany}/>

					<h3 style={{marginTop: "55px"}}>Frågor rörande lagen om penningtvätt och finansiering av terrorism</h3>

					<TypeOfCompany onUpdate={(fulfilled) => this.setState({
						fields: {...this.state.fields, typeOfCompanyFulfilled: fulfilled}
					})} />

					<OptionsList
						type="radio"
						orientation="horizontal"
						name="radio_company_fininst"
						description="Är företaget ett finansiellt institut?"
						options={state.fields.radio_company_fininst.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "30px"}}
					/>

					<OptionsList
						type="radio"
						orientation="horizontal"
						name="radio_company_active"
						description="Är företaget aktivt* eller passivt?"
						options={state.fields.radio_company_active.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "35px"}}
					/>

					<p style={{fontSize: "13px", color: "#666"}}>
						* Ett företag definieras som aktivt om minst 50 procent av företagets intäkter kommer från rörelse, till exempel
						försäljning av varor och tjänster. Andra exempel på aktiva företag är: 1. Uppstartsbolag (de två första åren) 2.
						Stiftelser och ideella föreningar som inte är skattskyldiga
					</p>

					<OptionsList
						type="radio"
						orientation="horizontal"
						name="radio_company_revisor"
						description="Har företaget en revisor?"
						options={state.fields.radio_company_revisor.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "15px"}}
					/>


					<NumberOfEmployees onUpdate={(fulfilled) => this.setState({
						fields: {...this.state.fields, numberOfEmployeesFulfilled: fulfilled}
					})} />

					<SizeOfTurnover onUpdate={(fulfilled) => this.setState({
						fields: {...this.state.fields, sizeOfTurnoverFulfilled: fulfilled}
					})} />

					<OriginOfCompanyFunds onUpdate={(fulfilled) => this.setState({
						fields: {...this.state.fields, originOfCompanyFundsFulfilled: fulfilled}
					})} />

					<SizeOfDeposits onUpdate={(fulfilled) => this.setState({
						fields: {...this.state.fields, sizeOfDepositsFulfilled: fulfilled}
					})} />

					<FrequencyOfDeposits onUpdate={(fulfilled) => this.setState({
						fields: {...this.state.fields, frequencyOfDepositsFulfilled: fulfilled}
					})} />

				</div>
			</div>
		);
	}

	// Internal methods
	_fieldValidator = (name, value) =>
	{
		if (name === "customer_social_security_number")
		{
			return this.props.session.isCompany ? Validator.validateOrgNum(value, true) : Validator.validateSsn(value, true);
		}
		else if (name === "customer_email")
		{
			return Validator.validateEmail(value);
		}
		else
		{
			return value.length > 0;
		}
	};

	_onFieldChange = (name, value) =>
	{
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) =>
	{
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onCheckboxChange = (name, checked) =>
	{
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};

	_onOptionsListChange = ({type, name}, option, index) =>
	{
		const newOptions = [...this.state.fields[name].options].map((o, i) =>
		{
			if (i === index)
			{
				return option;
			}
			else
			{
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions
				}
			}
		}, () => fulfillmentCheck(this.props, this.state));
	};

	_onUboChange = (valid) => {
		CobHelpers.onViewFieldChange.call(this, "ubo_fields_valid", valid);
	};

	_onPepChange = (valid) => {
		CobHelpers.onViewFieldChange.call(this, "pep_fields_valid", valid);
	};
}


// PRIVATE FUNCTIONS
function _getFields()
{
	return [

	];
}

function _getInitialState()
{
	if (this.props.prevState)
	{
		return {...this.props.prevState};
	}

	return {
		validFields: {},
		fields: {
			typeOfCompanyFulfilled: false,
			originOfCompanyFundsFulfilled: false,
			numberOfEmployeesFulfilled: false,
			sizeOfTurnoverFulfilled: false,
			sizeOfDepositsFulfilled: false,
			frequencyOfDepositsFulfilled: false,

			ubo_fields_valid: false,
			pep_fields_valid: false,

			customer_comp_histresult1: "",
			customer_comp_histresult2: "",
			customer_comp_histresult3: "",

			customer_comp_budresult12m: "",
			customer_comp_budresult24m: "",

			customer_comp_assets_cash: "",
			customer_comp_assets_fininstr: "",
			customer_comp_assets_other: "",
			customer_comp_assets_sum: "",

			company_business: "",
			radio_company_fininst: {options: _createYesNoOptions(true)},
			radio_company_active: {options: [
				{label: "Aktivt", value: "Ja", checked: false},
				{label: "Passivt", value: "Nej", checked: false}
			]},
			radio_company_revisor: {options: _createYesNoOptions(true)},
		}
	};
}

function _createYesNoOptions(swedish = false)
{
	if (swedish)
	{
		return [
			{label: "Nej", value: "Nej", checked: false},
			{label: "Ja", value: "Ja", checked: false}
		];
	}

	return [
		{label: "Nej", value: "no", checked: false},
		{label: "Ja", value: "yes", checked: false}
	];
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/Kyc/KycForetag.js